import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const BASE_URL = 'https://redevenirmoi.com/cart/53664651575664:1';
const BUMP_URL = 'https://redevenirmoi.com/cart/53697059324272:1';
export function CtaSection() {
  const [bumpChecked, setBumpChecked] = useState(false);
  return <section id="cta-section" className="bg-forest py-24 px-6 relative overflow-hidden" data-id="element-12">
      {/* Background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-forest-light opacity-20 blur-3xl rounded-full pointer-events-none" data-id="element-13"></div>

      <div className="max-w-[800px] mx-auto relative z-10 text-center" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-15">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-white leading-tight mb-8" data-id="element-16">
            Prêt à transformer votre espace en{' '}
            <span className="text-accent" data-id="element-17">mine d'or verte</span> ?
          </h2>

          <a href={bumpChecked ? BUMP_URL : BASE_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="inline-block w-full md:w-auto bg-accent hover:bg-accent-light text-forest-dark font-sans font-bold text-xl md:text-2xl py-6 px-10 rounded-xl shadow-[0_0_40px_rgba(233,196,106,0.3)] hover:shadow-[0_0_60px_rgba(233,196,106,0.5)] transition-all duration-300 transform hover:-translate-y-2 border-b-4 border-forest-dark/20 text-center" data-id="element-18">
            <span className="block" data-id="element-19">OUI, JE COMMENCE À PRODUIRE CHEZ MOI</span>
            <span className="block mt-1 text-base md:text-lg font-semibold opacity-90" data-id="element-20">
              → ACCÈS IMMÉDIAT {bumpChecked ? '26,97$' : '9,97$'}
            </span>
          </a>

          {/* Order Bump */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-21">
            <label htmlFor="order-bump" className={`block cursor-pointer rounded-xl border-2 border-dashed transition-all duration-300 overflow-hidden text-left ${bumpChecked ? 'border-urgency bg-amber-50 shadow-lg shadow-urgency/10' : 'border-urgency/60 bg-amber-50/90 hover:border-urgency hover:shadow-md'}`} data-id="element-22">
              {/* Bump header strip */}
              <div className="bg-urgency text-white py-2.5 px-5 flex items-center gap-2" data-id="element-23">
                <span className="text-lg animate-pulse-fast" data-id="element-24">⚡</span>
                <span className="font-sans font-bold text-sm md:text-base uppercase tracking-wider" data-id="element-25">
                  ATTENDS — Ajoute ça en 1 clic avant de partir
                </span>
              </div>

              <div className="p-5 md:p-6 flex flex-col md:flex-row md:gap-4 md:items-start" data-id="element-26">
                {/* Image — top on mobile, right on desktop */}
                <div className="flex justify-center md:order-last md:flex-shrink-0 mb-4 md:mb-0" data-id="element-27">
                  <img src="https://cdn.magicpatterns.com/uploads/7FabyyVHQZnxddSBJhhiP5/COVER_ORDER_BUMP.png" alt="Liste de Courses Ultime & Planificateur de Récolte 2026" className="w-full max-w-xs sm:max-w-sm md:max-w-none md:w-48 md:h-48 rounded-lg object-cover shadow-md" data-id="element-28" />
                </div>

                {/* Mobile: arrow down above checkbox */}
                <div className="flex md:hidden justify-center mb-2" data-id="element-29">
                  <span aria-hidden="true" className="text-urgency font-extrabold text-3xl leading-none" style={{
                  animation: 'bumpArrowDown 1s ease-in-out infinite'
                }} data-id="element-30">
                    ↓
                  </span>
                </div>

                {/* Checkbox + Text row */}
                <div className="flex gap-3 md:gap-4 md:flex-1 md:items-start" data-id="element-31">
                  {/* Desktop: arrow right of checkbox */}
                  <div className="hidden md:flex flex-shrink-0 pt-1 items-center" data-id="element-32">
                    <span aria-hidden="true" className="text-urgency font-extrabold text-3xl leading-none" style={{
                    animation: 'bumpArrow 1s ease-in-out infinite'
                  }} data-id="element-33">
                      →
                    </span>
                  </div>

                  {/* Checkbox */}
                  <div className="flex-shrink-0 pt-1" data-id="element-34">
                    <input type="checkbox" id="order-bump" checked={bumpChecked} onChange={e => setBumpChecked(e.target.checked)} className="w-6 h-6 rounded border-2 border-urgency text-urgency accent-urgency cursor-pointer" data-id="element-35" />
                  </div>

                  {/* Text */}
                  <div className="flex-1 min-w-0" data-id="element-36">
                    <p className="font-serif text-base md:text-lg font-bold text-urgency leading-snug mb-3" data-id="element-37">
                      👉 OUI — Ajoute la liste exacte de ce qu'il faut acheter +
                      le plan semaine par semaine pour ne jamais rater une
                      récolte
                    </p>
                    <p className="font-sans text-[15px] md:text-base text-charcoal/85 leading-relaxed" data-id="element-38">
                      Sans savoir quoi acheter et quand semer, tu vas gaspiller
                      temps et argent. Ce pack te donne la liste précise du
                      matériel + ton tableau de bord semaine par semaine.{' '}
                      <span className="font-semibold text-forest" data-id="element-39">
                        ✅ Zéro devinette. Zéro gaspillage. Récolte maximale dès
                        le premier mois.
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              {/* Price line */}
              <div className="px-5 md:px-6 pb-5 md:pb-6 pt-4 mt-2 border-t border-urgency/20 text-center" data-id="element-40">
                <p className="font-sans font-bold text-charcoal text-lg md:text-xl leading-tight" data-id="element-41">
                  Accès immédiat pour{' '}
                  <span className="font-extrabold text-2xl md:text-3xl" style={{
                  color: '#16a34a'
                }} data-id="element-42">
                    17$
                  </span>
                </p>
                <p className="line-through text-charcoal/40 font-normal text-sm mt-1" data-id="element-43">
                  (Valeur 47$)
                </p>
              </div>
            </label>
          </motion.div>

          <div className="pt-4 space-y-4 flex flex-col items-center justify-center" data-id="element-44">
            <div className="flex items-center gap-3 text-cream/90 bg-forest-dark/30 py-3 px-6 rounded-lg border border-forest-light/30" data-id="element-45">
              <ShieldCheck className="w-6 h-6 text-accent" data-id="element-46" />
              <p className="font-sans font-medium" data-id="element-47">
                Garantie 30 jours — Zéro risque : Si tu n'es pas satisfaite, tu
                es remboursée. Sans question, sans délai.
              </p>
            </div>

            <div className="flex items-center gap-2 text-cream/60 text-sm" data-id="element-48">
              <Lock className="w-4 h-4" data-id="element-49" />
              <p className="font-sans" data-id="element-50">
                Paiement sécurisé - Accès immédiat en téléchargement numérique
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}